import { Component } from "@angular/core";

@Component({
  selector: 'app',
  templateUrl: './service-access-disabled.component.html',
  styleUrls: ['./service-access-disabled.component.scss']
})
export class ServiceAccessDisabledComponent {
  retry() {
    window.location.reload();
  }
}